import React from 'react';
import { CBadge } from '@coreui/react';

const AGING_CONFIG = {
  '0-7': { color: 'success', label: 'Fresh' },
  '8-14': { color: 'warning', label: 'Warning' },
  '15-30': { color: 'info', label: 'Urgent' },
  '>30': { color: 'danger', label: 'Critical' },
};

export function getAgingGroup(days) {
  if (days <= 7) return '0-7';
  if (days <= 14) return '8-14';
  if (days <= 30) return '15-30';
  return '>30';
}

export function getAgingConfig(group) {
  return AGING_CONFIG[group] || AGING_CONFIG['0-7'];
}

export default function AgingBadge({ days, group, showDays = true }) {
  const agingGroup = group || getAgingGroup(days || 0);
  const config = getAgingConfig(agingGroup);

  return (
    <CBadge
      data-testid={`aging-badge-${agingGroup}`}
      color={config.color}
      shape="rounded-pill"
      className={`${agingGroup === '>30' ? 'aging-critical' : ''}`}
    >
      {config.label}
      {showDays && days !== undefined && (
        <span className="ms-1 opacity-75">({days}d)</span>
      )}
    </CBadge>
  );
}
